import axios from "axios";
//import FormData from "form-data";
import {AdminDashboardEndPoint,AdminDashboardMMSCMEndPoint, AdminEditBaseDailyFlowEndPoint, AdminSectorFlowRateDataEndPoint, AdminSectorFlowRateLast24DataEndPoint, AdminSectorWiseCustomersDataEndPoint} from "../../../config/AppServerConfig";
import {GlobalConfig} from "./../../../Services/Helper/GlobalConfig";

// axios.interceptors.response.use((response) => {
//   return response;
// }, function (error) {
//   return Promise.reject(error.response);
// });

class AdminDashboardDataServices {
    static getDashboardData() {

        const config = {
            headers: {"Authorization": GlobalConfig.Token}
        };
        return axios.get(AdminDashboardEndPoint+'/1', config);
    }

    static getDashboardVolumnData() {

        const config = {
            headers: {"Authorization": GlobalConfig.Token}
        };
        return axios.get(AdminDashboardEndPoint+'/2', config);
    }

    static getDashboardMMSCMEData() {

        const config = {
            headers: {"Authorization": GlobalConfig.Token}
        };
        return axios.get(AdminDashboardMMSCMEndPoint, config);
    }
    static getDashboardDailyFlow() {

        const config = {
            headers: {"Authorization": GlobalConfig.Token}
        };
        return axios.get(AdminEditBaseDailyFlowEndPoint, config);
    }
    static getSectorFlowRateData() {

        const config = {
            headers: {"Authorization": GlobalConfig.Token}
        };
        return axios.get(AdminSectorFlowRateDataEndPoint, config);
    }
    static getSectorFlowRateLast24Data() {

        const config = {
            headers: {"Authorization": GlobalConfig.Token}
        };
        return axios.get(AdminSectorFlowRateLast24DataEndPoint, config);
    }
    static getSectorWiseCustomers(sectorId) {

        const config = {
            headers: {"Authorization": GlobalConfig.Token}
        };
        return axios.get(AdminSectorWiseCustomersDataEndPoint+"?sectorId="+sectorId, config);
    }

}

export {AdminDashboardDataServices, };
